import React from 'react';
import { useParams } from 'react-router-dom';

import { ArquivoLista } from 'Component/Arquivo';
import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import Usuario from 'Interface/Usuarios';
import { useRecuperarUsuariosQuery } from 'Service';
import { useRecuperarArquivosQuery } from 'View/Service/Default/Arquivos';

const Arquivos = (): React.ReactElement => {
  const { id = 0 } = useParams();

  const {
    data: { arquivos, paginacao } = {},
    isFetching,
    isLoading,
    refetch,
  } = useRecuperarArquivosQuery({
    options: { entidade: 'usuarios', entidade_id: id },
    sort: 'Arquivos.nome',
    direction: 'asc',
  });

  const {
    data: { usuarios: [arquivosFaltando] } = { usuarios: [{} as Usuario] },
  } = useRecuperarUsuariosQuery({
    finder: 'faltandoDocumentacao',
    options: { usuario_id: id },
  });

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6 mb-3">
          <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
          <BotaoLink
            tema="success"
            icone="plus-lg"
            to={`/arquivos/adicionar/usuarios/${id}`}
          >
            Adicionar
          </BotaoLink>
        </div>
      </div>
      {arquivosFaltando && (
        <div className="mb-3">
          <p className="fs-5 mb-0">
            Lista de documentos obrigatórios não enviados
          </p>
          {Object.keys(arquivosFaltando)
            .filter((documento: string) => !arquivosFaltando[documento])
            .map((arquivo) => (
              <span key={arquivo} className="badge bg-danger fs-6 me-2 mb-2">
                {arquivo}
              </span>
            ))}
        </div>
      )}
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={arquivos?.length}
        redirecionar={`/arquivos/adicionar/usuarios/${id}`}
      />
      <div className="bg-white shadow-sm rounded">
        {arquivos?.map((arquivo) => (
          <ArquivoLista
            key={`${arquivo.id}-${arquivo.modificado}`}
            dados={arquivo}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </React.Fragment>
  );
};

export default Arquivos;
